import { css } from '@emotion/react';
import { useTranslation, Trans } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text, AnalyticsIcon, ClockIcon, SupportIcon } from '@frontend/design-system';

const styles = {
  sunbitVideo: css`
    max-width: 450px;
  `,
};

export const BuyNowPayLaterInfo = () => {
  const { t } = useTranslation('payments');

  const snippets = [
    {
      icon: <AnalyticsIcon />,
      title: t('Drive more business'),
      subtitle: t('90% Approval rate*'),
    },
    {
      icon: <ClockIcon />,
      title: t('30 seconds to apply'),
      subtitle: t('No hard credit check to apply'),
    },
    {
      icon: <SupportIcon />,
      title: t('Great support & training'),
      subtitle: t('95% Customer satisfaction*'),
    },
  ];

  return (
    <div
      css={css`
        margin-top: ${theme.spacing(10)};
        max-width: ${theme.spacing(75)};
      `}
    >
      <Heading level={2}>{t('Learn More About Sunbit')}</Heading>
      <div
        css={css`
          margin-top: ${theme.spacing(3.5)};
          margin-bottom: ${theme.spacing(3)};
        `}
      >
        <iframe
          src='https://player.vimeo.com/video/712979693?h=7750837a64'
          title={t('Sunbit Educational Content')}
          frameBorder='0'
          allow='autoplay; fullscreen'
          allowFullScreen
          scrolling='no'
          width='100%'
          height='250'
          css={styles.sunbitVideo}
        />
      </div>
      <Text color='light' size='medium'>
        {t(
          "Many Americans can't afford a $400 unexpected expense, which may result in a decline in services, loss of revenue and overall a hardship on consumers. Weave and Sunbit have partnered to help you drive more business and serve more customers, with buy now, pay-over-time flexible payment options."
        )}
      </Text>
      <Heading level={2} css={{ margin: theme.spacing(2, 0) }}>
        {t('Why Sunbit?')}
      </Heading>
      <Text color='light' size='medium'>
        {t(
          'Sunbit is the preferred buy now, pay-over-time consumer financing technology for everyday needs, offering fast, fair, and transparent payment options to over 90% of applicants.*'
        )}
      </Text>
      <Trans t={t}>
        <Text color='light' size='medium' css={{ marginTop: theme.spacing(1) }}>
          Minimum Purchase: <span css={{ fontWeight: theme.font.weight.bold }}>$60</span>
          <br />
          Max Approval: <span css={{ fontWeight: theme.font.weight.bold }}>$20,000</span>
        </Text>
      </Trans>
      <div
        css={css`
          display: flex;
          flex-flow: column;
          @media only screen and (min-width: 600px) {
            flex-flow: row;
          }
          justify-content: space-between;
          margin-top: ${theme.spacing(5)};
          margin-bottom: ${theme.spacing(4)};
        `}
      >
        {snippets.map(({ icon, title, subtitle }) => (
          <div
            key={title}
            css={css`
              display: flex;
              flex-flow: column;
              align-items: center;
            `}
          >
            {icon}
            <Text
              weight='bold'
              size='medium'
              css={css`
                margin-top: ${theme.spacing(1)};
                margin-bottom: 0;
              `}
            >
              {title}
            </Text>
            <Text color='light' size='medium'>
              {subtitle}
            </Text>
          </div>
        ))}
      </div>
      <Trans t={t}>
        <Text color='light' size='small'>
          Loans are made by TAB Bank.
          <br />* All figures are provided by Sunbit.
        </Text>
      </Trans>
    </div>
  );
};
